import React from "react";
import useSecurityObject from "src/hooks/useSecurityObject";

export interface SafetyComponentBaseProps {
    code: string,
    permissionWorkflowCode?: number
}

interface SafetyComponentProps extends SafetyComponentBaseProps {
    children: React.ReactElement,
    dict?: any
}

export function SafetyComponent (props: SafetyComponentProps) {
    const {
        hasReadPermission, hasWritePermission, hasReadWorkflowPermission, hasWriteWorkflowPermission
    } = useSecurityObject();

    const readPermission : boolean =
        (props.permissionWorkflowCode != undefined) ?
            hasReadWorkflowPermission(props.permissionWorkflowCode, props.code) :
            hasReadPermission(props.code);
    const writePermission : boolean =
        (props.permissionWorkflowCode != undefined) ?
            hasWriteWorkflowPermission(props.permissionWorkflowCode, props.code) :
            hasWritePermission(props.code);

    if (props.dict && readPermission) {
        props.dict.push(React.cloneElement(props.children, { disabled: !writePermission }))

        return null
    }

    return (
        readPermission ?
            React.cloneElement(props.children, { disabled: !writePermission })
            :
            null
    );
}

